/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Street/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromValidate from 'Data/validate.js'
import React from 'react'
import TysiaInput from 'DesignSystem/TysiaInput/index'
import TysiaInputContent from 'DesignSystem/TysiaInput/TysiaInputContent/index'
import TysiaInputField from 'DesignSystem/TysiaInput/TysiaInputField/index'
import TysiaInputLabel from 'DesignSystem/TysiaInput/TysiaInputLabel/index'



/** @type {import('Simple/types.js').View} */
export default function Street({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Profile/Content/ContactInfo/Email/NewEmail/Content/NewRelation/Add/Content/Address/Street",
  isInvalid,
  onChange,
  onChooseAddress
  
}) {
let newRelationAddressAddressLine1ValueData = fromData.useDataValue({ viewPath,
context: 'new_relation',
path: 'address.address_line1',
})
let newRelationAddressAddressLine1IsValidData = fromData.useDataIsValid({ viewPath,
context: 'new_relation',
path: 'address.address_line1',
validate: fromValidate.street,
})
let newRelationAddressAddressLine1ChangeData = fromData.useDataChange({ viewPath,
context: 'new_relation',
path: 'address.address_line1',
})
  return (<React.Fragment
>
<TysiaInput
  viewPath={`${viewPath}/TysiaInput`}
 data="new_relation.address.address_line1"
 validate="/Data/validate.js street"
 invalid={!newRelationAddressAddressLine1IsValidData}
 value={newRelationAddressAddressLine1ValueData}
 onChange={newRelationAddressAddressLine1ChangeData}
>
{childProps => (
<React.Fragment>
<TysiaInputLabel
{...childProps}
  viewPath={`${viewPath}/TysiaInputLabel`}
 text="Street"
/>
<TysiaInputContent
{...childProps}
  viewPath={`${viewPath}/TysiaInputContent`}
>
{childProps => (
<TysiaInputField
{...childProps}
  viewPath={`${viewPath}/TysiaInputField`}
 focusOnDownArrowKey={true}
 onChooseAddress={onChooseAddress}
 type="address"
/>
)}
</TysiaInputContent>
</React.Fragment>
)}
</TysiaInput>
{children}
</React.Fragment>)
}